import React from 'react'

export default function Mossad() {
  return (
    <>
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="95.000000pt" height="100.000000pt" viewBox="0 0 800.000000 800.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,800.000000) scale(0.100000,-0.100000)"
fill="#ffffff" stroke="none">
<path d="M3810 7994 c-420 -28 -733 -87 -1083 -204 -801 -268 -1505 -793
-2001 -1495 -580 -821 -828 -1862 -681 -2868 187 -1284 978 -2390 2135 -2984
420 -215 870 -351 1380 -415 143 -18 737 -18 880 0 918 116 1704 488 2339
1107 181 177 285 294 418 473 427 570 682 1213 775 1952 18 143 18 737 0 880
-23 181 -60 384 -97 530 -369 1468 -1524 2596 -3000 2931 -326 73 -770 112
-1065 93z m356 -84 c742 -34 1402 -251 2014 -660 799 -535 1381 -1362 1614
-2295 87 -347 111 -558 110 -960 0 -398 -22 -591 -109 -944 -224 -912 -806
-1748 -1585 -2277 -539 -366 -1085 -572 -1755 -661 -190 -25 -716 -25 -910 0
-586 77 -1067 241 -1550 528 -1131 674 -1843 1863 -1905 3180 -44 962 254
1875 864 2639 126 158 424 456 581 582 661 529 1443 829 2265 868 85 4 160 7
165 8 6 1 96 -3 201 -8z"/>
<path d="M3924 7627 l-129 -102 55 -5 c30 -3 55 -7 54 -10 0 -3 -4 -52 -8
-110 -4 -58 -9 -119 -12 -137 -4 -23 -1 -36 15 -52 19 -19 32 -21 170 -21 123
0 152 -3 165 -16 9 -8 16 -21 16 -29 0 -22 -86 -184 -164 -310 -42 -65 -73
-121 -71 -123 10 -10 96 52 142 101 60 67 160 212 201 293 42 83 48 123 27
168 -28 58 -54 66 -217 66 l-144 0 17 192 c10 106 16 194 15 195 -1 2 -60 -43
-132 -100z"/>
<path d="M4645 7433 c-66 -35 -124 -69 -129 -74 -6 -5 -2 -17 11 -31 57 -61
51 -144 -27 -395 -27 -89 -50 -164 -50 -168 0 -16 63 41 109 99 126 158 221
425 209 588 l-3 47 -120 -66z"/>
<path d="M3621 7396 l-84 -85 30 -25 c58 -49 66 -89 65 -300 l-1 -189 24 33
c27 37 58 112 83 205 31 115 15 445 -22 445 -6 0 -49 -38 -95 -84z"/>
<path d="M4946 7292 c-16 -19 -52 -49 -78 -67 l-49 -33 63 -35 c35 -19 97 -51
138 -72 41 -21 76 -38 78 -40 1 -1 -12 -62 -30 -135 l-33 -133 -105 7 c-58 4
-145 9 -195 12 l-90 6 -33 -58 c-21 -36 -29 -60 -22 -64 5 -3 135 -12 287 -19
l278 -12 28 33 c48 58 51 67 23 79 -14 7 -27 17 -30 24 -2 7 15 86 39 177 l43
165 -103 47 c-101 47 -139 76 -166 127 l-14 25 -29 -34z"/>
<path d="M2853 7228 c-68 -92 -68 -95 22 -97 62 -2 68 -10 42 -56 -20 -36 -22
-54 -22 -178 l0 -138 -37 -34 c-25 -23 -50 -36 -82 -40 -45 -7 -45 -7 -61 -64
-9 -31 -26 -71 -37 -89 -33 -54 -9 -54 81 0 208 126 291 252 315 472 l11 110
30 7 c17 4 61 9 98 13 l68 5 21 -47 c11 -26 33 -109 48 -186 16 -76 31 -140
34 -143 7 -7 52 84 75 155 27 78 27 168 1 291 -11 52 -22 97 -25 100 -3 2 -74
-3 -158 -13 -141 -17 -158 -17 -242 -2 -49 9 -97 16 -105 16 -9 0 -43 -37 -77
-82z"/>
<path d="M5423 7084 c-61 -25 -62 -27 -48 -47 34 -48 11 -157 -64 -305 l-32
-63 30 15 c49 26 149 111 193 165 23 28 44 51 47 51 3 0 35 -15 71 -33 48 -23
66 -38 68 -55 6 -37 -35 -115 -155 -299 l-15 -22 63 25 c35 13 80 35 100 48
35 23 112 128 140 189 7 15 18 26 25 23 7 -3 29 -8 48 -11 32 -7 37 -5 46 20
14 36 13 90 -2 103 -7 5 -51 18 -96 27 -165 33 -256 78 -317 156 -16 21 -32
38 -35 38 -3 0 -33 -11 -67 -25z"/>
<path d="M2308 6945 l-35 -115 24 0 c31 0 73 -22 156 -81 37 -27 67 -45 67
-40 0 38 -28 129 -60 196 -36 75 -92 155 -109 155 -4 0 -23 -52 -43 -115z"/>
<path d="M2050 6753 c-14 -2 -59 -22 -100 -44 -41 -22 -103 -53 -137 -69 l-63
-30 0 -65 c0 -36 2 -65 5 -65 2 0 26 10 51 23 27 12 49 18 51 12 55 -147 93
-230 105 -229 7 1 33 13 56 27 l41 27 -21 59 -22 60 -29 -15 c-39 -21 -52 -14
-67 40 -16 58 -10 66 82 112 96 48 115 46 177 -22 71 -77 69 -95 -16 -243 -85
-148 -113 -209 -113 -245 0 -32 39 -102 50 -89 3 4 71 122 149 261 l142 253
-32 42 c-64 83 -145 160 -194 183 -49 23 -63 25 -115 17z"/>
<path d="M6038 6683 c-32 -2 -58 -6 -58 -9 0 -3 18 -31 41 -62 l40 -57 -50 -6
c-56 -7 -72 -19 -151 -103 -68 -73 -126 -102 -174 -86 -18 6 -47 21 -65 34
l-33 24 -61 -29 c-34 -16 -74 -29 -89 -29 -20 0 -28 -5 -28 -18 0 -15 21 -24
113 -48 237 -61 395 -29 560 114 34 30 52 39 65 34 31 -12 171 -126 172 -140
0 -21 -68 -150 -133 -250 -33 -51 -57 -95 -55 -97 6 -7 134 38 187 64 24 12
62 40 85 61 39 36 150 181 158 206 2 6 -44 51 -102 101 -121 103 -153 138
-217 234 l-46 69 -51 -2 c-28 -1 -77 -3 -108 -5z"/>
<path d="M1506 6327 c-4 -56 -9 -116 -13 -134 -5 -32 -5 -32 29 -27 74 12 136
-35 284 -217 54 -65 99 -117 101 -115 2 2 -3 35 -11 74 -18 87 -71 204 -130
286 -47 67 -173 189 -223 218 l-30 18 -7 -103z"/>
<path d="M883 6035 c4 -22 7 -98 7 -170 l1 -130 33 38 c18 20 37 37 41 37 4 0
46 -36 93 -81 102 -96 125 -113 150 -105 11 4 56 53 99 109 44 56 90 111 102
121 33 30 61 10 103 -75 36 -75 138 -339 138 -358 0 -6 4 -11 9 -11 15 0 24
85 17 145 -9 80 -72 278 -116 372 -29 59 -49 87 -74 102 -33 21 -79 27 -110
15 -9 -3 -57 -58 -107 -121 -50 -63 -94 -113 -99 -111 -5 2 -62 53 -127 113
-65 61 -129 119 -142 130 l-24 20 6 -40z"/>
<path d="M6779 5923 l-57 -4 5 -37 c3 -26 -2 -47 -15 -68 -25 -39 -138 -123
-320 -238 -78 -50 -140 -91 -139 -93 6 -6 203 49 275 77 152 59 375 184 380
215 2 9 -4 35 -13 56 -11 24 -15 49 -12 69 6 28 5 30 -21 28 -15 -1 -52 -3
-83 -5z"/>
<path d="M3923 5826 c-53 -17 -109 -52 -117 -72 -3 -9 -6 -35 -6 -59 0 -38 6
-51 46 -96 l45 -51 -7 -82 c-3 -44 -12 -88 -20 -96 -11 -13 -10 -20 6 -44 18
-28 18 -30 -1 -56 -17 -22 -18 -31 -9 -55 6 -16 16 -32 21 -36 6 -4 5 -22 -5
-49 -13 -38 -13 -47 0 -72 12 -24 13 -32 3 -45 -8 -8 -15 -53 -17 -104 -3 -49
-8 -89 -11 -89 -4 0 -30 7 -58 15 -39 12 -67 30 -112 75 -34 33 -61 66 -61 74
0 7 -11 30 -25 50 -14 20 -25 45 -25 55 0 10 -7 24 -16 31 -20 17 -44 75 -44
109 0 14 1 82 2 151 3 138 10 159 83 255 39 50 49 102 25 130 -17 20 -99 35
-195 35 -91 0 -128 -10 -162 -42 -29 -27 -29 -57 1 -116 37 -73 48 -126 51
-257 4 -123 25 -241 63 -345 12 -30 26 -74 32 -98 13 -50 53 -106 146 -202 74
-76 156 -124 244 -141 52 -10 56 -13 67 -48 9 -28 9 -47 1 -75 -14 -43 -12
-43 -141 20 -49 23 -102 46 -118 49 -17 4 -42 18 -56 31 -14 13 -32 24 -40 24
-7 0 -23 12 -36 27 -12 14 -49 56 -82 93 -105 116 -180 243 -188 319 -4 30
-13 61 -22 71 -9 10 -15 36 -15 71 0 30 -5 72 -10 94 -6 22 -10 111 -10 198 0
140 3 162 22 202 44 90 -7 145 -132 145 -74 0 -122 -20 -154 -62 l-20 -28 31
-62 c43 -87 50 -122 58 -283 7 -172 37 -372 66 -451 38 -103 177 -340 222
-379 22 -19 44 -35 48 -35 4 0 17 -16 29 -35 12 -19 32 -40 44 -47 75 -41 94
-53 119 -74 16 -13 35 -24 42 -24 8 0 31 -11 51 -25 20 -14 45 -25 55 -25 10
0 47 -11 81 -24 35 -12 84 -26 111 -30 34 -5 47 -12 48 -24 3 -42 -4 -118 -11
-126 -13 -13 -199 36 -296 77 -88 37 -252 139 -299 186 -16 17 -40 34 -52 38
-29 11 -181 179 -221 246 -18 29 -36 73 -41 97 -5 25 -32 100 -60 168 -32 78
-51 138 -51 163 0 22 -7 54 -16 71 -11 21 -15 46 -11 77 4 31 -1 65 -13 102
-13 38 -21 98 -25 185 -4 116 -3 133 15 167 38 71 19 128 -49 147 -78 21 -181
-13 -201 -66 -8 -20 -5 -36 12 -72 20 -44 21 -60 19 -227 -2 -140 3 -212 19
-325 12 -80 25 -176 30 -213 6 -45 22 -91 45 -135 19 -37 41 -87 50 -111 8
-25 26 -58 38 -75 13 -17 32 -51 42 -76 11 -25 49 -80 85 -122 36 -43 79 -96
95 -118 60 -81 77 -100 91 -100 7 0 21 -11 30 -26 9 -14 31 -32 48 -41 17 -9
45 -28 63 -44 17 -15 48 -33 67 -40 20 -7 36 -19 36 -26 0 -17 33 -33 67 -33
16 0 37 -6 48 -13 35 -24 179 -65 253 -73 l72 -7 0 -68 c0 -51 3 -69 13 -69
19 0 47 -33 47 -54 0 -10 8 -29 19 -42 16 -20 17 -29 7 -57 -6 -18 -21 -45
-33 -61 -13 -16 -23 -37 -23 -47 0 -12 -7 -19 -21 -19 -18 0 -20 -5 -17 -47 3
-46 5 -48 34 -51 26 -3 33 -8 38 -34 12 -60 7 -73 -58 -140 -69 -71 -99 -134
-112 -227 -13 -102 -66 -121 -330 -121 l-194 0 0 -255 0 -255 -160 0 -160 0 0
-280 0 -280 1195 0 1195 0 0 280 0 280 -155 0 -155 0 0 255 0 255 -197 0
c-178 0 -201 2 -239 21 -47 22 -48 24 -64 117 -16 93 -41 142 -109 212 -48 50
-61 69 -61 94 0 58 10 76 41 76 23 0 29 4 29 23 0 12 -4 18 -8 12 -4 -5 -34
-10 -67 -10 -52 0 -64 4 -90 28 -33 30 -34 31 -68 18 -34 -13 -53 0 -36 27 17
27 44 31 99 14 25 -7 64 -13 87 -12 30 1 48 -5 63 -20 20 -20 20 -20 20 0 0
11 -7 20 -15 20 -8 0 -15 9 -15 19 0 11 -11 32 -23 48 -18 21 -47 82 -47 98 0
1 9 12 20 25 11 13 20 34 20 47 0 18 8 28 30 36 29 11 30 13 30 78 l0 66 38
11 c20 6 77 20 126 32 48 11 98 27 109 35 12 8 38 15 59 15 39 0 88 17 88 32
0 4 10 8 21 8 12 0 37 17 57 37 19 21 51 45 71 54 20 9 56 32 79 53 24 20 48
36 53 36 5 0 15 12 23 28 8 15 41 55 73 89 32 33 67 76 78 94 11 18 30 48 43
68 12 20 27 54 34 76 6 22 19 49 29 60 34 39 100 230 128 365 36 180 45 301
33 471 -12 155 -10 178 21 249 20 46 12 84 -25 115 -25 21 -40 25 -97 25 -86
0 -131 -26 -146 -84 -8 -32 -6 -44 12 -75 33 -58 33 -248 -1 -476 -9 -55 -15
-117 -16 -137 0 -20 -11 -74 -25 -120 -72 -236 -78 -252 -131 -318 -28 -36
-74 -100 -102 -142 -40 -59 -62 -81 -98 -100 -26 -12 -53 -33 -61 -45 -13 -20
-90 -68 -201 -127 -20 -11 -75 -30 -122 -43 -47 -13 -119 -32 -160 -43 -41
-11 -82 -23 -91 -25 -13 -5 -18 4 -23 39 -12 79 -5 88 92 118 48 14 109 32
135 39 27 7 64 23 83 35 19 13 46 27 59 30 14 3 29 12 33 18 4 7 30 20 57 31
28 10 61 32 75 48 14 16 53 58 88 93 57 58 74 84 55 84 -4 0 -16 -11 -28 -25
l-20 -26 -37 27 c-46 33 -48 48 -8 64 19 8 30 20 30 32 0 10 7 21 15 24 20 8
64 -21 74 -48 16 -43 107 165 155 353 22 85 39 312 32 419 -6 103 10 212 38
252 25 35 20 71 -15 104 -27 26 -37 29 -92 29 -50 0 -72 -6 -110 -28 -51 -30
-87 -77 -87 -114 0 -12 9 -38 21 -57 12 -20 26 -75 35 -132 13 -87 13 -107 -2
-192 -10 -59 -13 -115 -9 -148 4 -33 2 -54 -4 -59 -6 -3 -11 -26 -11 -51 0
-31 -10 -64 -29 -102 -16 -31 -44 -87 -61 -123 -27 -56 -40 -72 -91 -104 -32
-22 -71 -56 -85 -77 -14 -20 -35 -40 -45 -43 -11 -4 -31 -17 -47 -29 -15 -13
-38 -27 -52 -31 -14 -4 -71 -30 -127 -58 -56 -28 -104 -49 -106 -47 -3 3 -7
40 -8 83 l-4 79 74 19 c41 10 98 30 128 44 65 29 160 124 216 213 44 72 104
222 112 283 3 24 11 61 17 81 9 30 8 46 -3 75 -13 33 -13 60 -1 203 21 253 22
249 -11 273 -22 17 -46 22 -122 25 l-95 4 -44 -44 c-65 -64 -66 -81 -12 -161
53 -79 62 -109 76 -246 9 -85 8 -112 -5 -164 -9 -33 -22 -68 -30 -77 -8 -9
-15 -26 -15 -37 0 -11 -9 -28 -20 -38 -10 -9 -24 -34 -31 -54 -22 -69 -114
-143 -194 -156 -22 -4 -47 -9 -56 -11 -15 -4 -17 10 -21 103 -4 84 -1 114 10
134 9 16 12 34 8 45 -9 21 -16 107 -20 224 -2 41 -7 105 -11 141 l-8 67 52 85
c28 47 51 93 51 104 0 67 -179 131 -277 99z m180 -77 c36 -39 35 -75 -5 -130
-30 -40 -33 -50 -32 -109 1 -36 5 -93 9 -127 6 -50 4 -68 -9 -88 -15 -22 -21
-24 -64 -19 -26 4 -53 12 -61 20 -12 10 -8 15 23 28 57 24 70 64 57 188 -10
98 -26 138 -55 138 -23 0 -86 21 -86 29 0 4 21 8 48 9 60 3 96 29 100 71 3 28
6 31 25 26 12 -4 34 -20 50 -36z m936 -18 c11 -20 0 -73 -20 -97 -8 -10 -10
-55 -7 -153 3 -77 2 -144 -1 -150 -9 -13 -57 -31 -87 -31 -24 0 -34 25 -13 32
16 5 23 91 11 126 -8 23 -7 31 8 40 23 14 31 69 15 108 -10 24 -22 34 -50 40
-53 13 -47 27 18 44 36 10 63 23 73 38 19 27 40 28 53 3z m359 -4 c17 -13 12
-50 -18 -132 -21 -57 -21 -62 -6 -111 23 -73 21 -110 -8 -129 -18 -12 -30 -13
-50 -6 -31 13 -32 20 -5 55 20 25 20 31 10 108 -10 77 -14 85 -52 124 -47 47
-49 80 -9 102 28 14 116 8 138 -11z m-2658 -211 c-8 -216 -8 -216 -67 -216
-43 0 -61 30 -33 55 11 10 22 37 26 64 3 25 15 61 26 80 26 46 17 93 -22 121
-39 28 -38 45 5 65 19 9 39 23 46 31 7 8 15 11 19 7 4 -4 4 -97 0 -207z m376
186 c9 -5 9 -23 3 -62 -5 -30 -7 -104 -3 -165 6 -115 -2 -160 -32 -172 -30
-11 -38 12 -24 71 15 63 9 95 -25 132 -18 19 -25 38 -25 67 0 31 -7 48 -26 68
-45 47 -24 63 86 67 19 1 40 -2 46 -6z m414 -12 c28 -15 25 -42 -10 -97 -27
-42 -30 -54 -28 -121 2 -72 2 -75 -30 -103 -36 -32 -63 -37 -82 -14 -13 16 -6
32 27 58 29 23 29 39 -2 85 -15 22 -25 51 -25 73 0 30 -6 41 -35 63 -37 29
-38 51 -1 67 26 11 160 3 186 -11z m1140 -21 c0 -7 -5 -29 -12 -50 -8 -29 -8
-52 0 -92 6 -28 13 -81 16 -115 4 -53 1 -67 -15 -83 -24 -24 -70 -24 -99 -1
-27 22 -19 42 15 42 29 0 58 39 53 72 -2 16 -11 24 -32 28 -26 4 -27 6 -13 19
25 20 21 38 -12 49 -16 6 -35 21 -42 34 -6 13 -26 35 -43 50 -30 27 -30 28
-12 43 25 19 196 22 196 4z m730 -350 c0 -10 -57 -22 -70 -14 -22 14 -8 25 30
23 22 -1 40 -5 40 -9z m-717 -33 c3 -8 3 -24 0 -36 -6 -22 -19 -23 -78 0 -39
15 -32 33 10 26 27 -5 37 -3 41 9 8 19 20 19 27 1z m-1183 -10 c0 -17 -116
-29 -142 -15 -34 18 -8 29 68 29 56 0 74 -3 74 -14z m1895 -6 c8 -24 -3 -97
-14 -105 -5 -2 -28 3 -52 12 -83 32 -89 48 -23 65 25 7 50 21 55 30 13 24 26
23 34 -2z m-2250 -5 c0 -11 -111 -26 -137 -19 -10 3 -18 12 -18 20 0 12 15 14
78 12 43 -2 77 -7 77 -13z m1863 -45 c34 -66 -35 -167 -79 -114 -11 14 -10 21
4 46 9 16 17 38 17 48 0 53 34 65 58 20z m-2230 -52 c-3 -57 -6 -64 -30 -76
-29 -14 -78 -7 -78 12 0 6 15 21 34 33 24 15 35 32 40 57 4 22 13 36 22 36 12
0 14 -12 12 -62z m1866 30 c34 -48 10 -61 -58 -33 -20 8 -36 17 -36 20 0 7 53
34 67 35 6 0 19 -10 27 -22z m-1164 -43 c0 -15 -40 -30 -62 -23 -8 3 -1 11 17
21 38 20 45 21 45 2z m-325 -36 c9 -26 -11 -49 -42 -49 -25 0 -43 27 -26 39 6
3 15 16 22 29 10 18 15 21 26 12 8 -7 17 -21 20 -31z m2212 -5 c18 -25 16 -34
-8 -34 -26 0 -101 20 -113 31 -4 4 -5 12 -1 19 11 18 106 6 122 -16z m-1283
-10 c22 -57 -2 -79 -80 -72 -56 4 -54 32 4 36 37 3 42 6 42 28 0 27 24 33 34
8z m552 -9 c9 -22 -4 -63 -26 -85 -18 -18 -23 -19 -52 -7 -42 17 -45 33 -10
51 16 8 32 24 35 36 6 24 45 28 53 5z m-1096 -5 c13 -9 13 -11 0 -20 -8 -5
-33 -10 -55 -10 -23 0 -47 -6 -53 -12 -10 -10 -15 -10 -22 2 -5 8 -6 18 -3 23
15 24 105 36 133 17z m1415 -60 c24 -9 25 -13 19 -47 -7 -42 -22 -75 -37 -84
-13 -9 -44 0 -58 17 -9 11 -6 19 15 39 34 31 29 49 -12 53 -20 2 -32 9 -32 18
0 17 64 19 105 4z m-1377 -53 c2 -10 -2 -25 -10 -34 -14 -17 -77 -47 -84 -40
-6 6 17 58 35 80 18 22 55 18 59 -6z m506 -45 c8 -58 7 -65 -13 -85 -17 -18
-32 -22 -71 -20 -99 4 -118 40 -40 74 39 17 50 26 50 44 0 42 11 56 39 53 24
-3 27 -8 35 -66z m1276 52 c0 -8 -12 -36 -26 -60 -28 -48 -33 -49 -99 -24 -32
12 -33 30 -1 30 38 0 56 10 72 41 16 31 54 40 54 13z m-2575 -70 c34 -37 37
-85 6 -117 -16 -16 -19 -16 -49 -1 -30 14 -44 44 -22 44 6 0 10 6 10 14 0 8 7
16 15 20 19 7 19 35 0 42 -16 6 -11 24 6 24 6 0 21 -12 34 -26z m1795 -1 c0
-10 -9 -29 -19 -43 -16 -20 -21 -22 -35 -11 -24 20 -20 38 12 55 35 20 42 20
42 -1z m-1435 -14 c10 -15 -1 -23 -20 -15 -9 3 -13 10 -10 16 8 13 22 13 30
-1z m493 -11 c2 -11 -10 -24 -36 -37 -57 -29 -72 -9 -25 35 29 27 56 28 61 2z
m856 -40 c15 -24 -11 -67 -51 -86 -31 -15 -34 -15 -58 8 -32 30 -33 60 -2 60
13 0 32 9 42 20 22 24 53 23 69 -2z m399 5 c46 -17 56 -26 38 -37 -7 -5 -37 3
-109 29 -15 6 -7 25 11 25 7 0 33 -8 60 -17z m387 -10 c33 -23 40 -33 40 -65
0 -47 -70 -66 -104 -29 -16 18 -16 20 4 34 16 11 20 21 15 36 -3 11 -11 20
-17 18 -6 -1 -13 4 -15 11 -7 18 48 15 77 -5z m-2112 -10 c-4 -23 -54 -41 -69
-26 -8 8 -3 15 17 27 38 20 56 20 52 -1z m472 -58 c25 -40 55 -58 149 -90 117
-39 80 -63 -40 -25 -109 34 -169 84 -154 130 9 29 20 25 45 -15z m1268 0 c8
-7 -20 -45 -33 -45 -22 0 -65 22 -65 33 0 6 7 18 16 28 15 17 19 17 48 2 17
-8 32 -17 34 -18z m-1698 -22 c0 -14 -34 -43 -52 -43 -23 0 -23 19 0 36 18 14
52 19 52 7z m1134 -16 c17 -27 -29 -61 -122 -90 -135 -43 -269 -44 -285 -3 -4
11 13 15 81 18 95 5 183 32 241 73 41 28 69 28 85 2z m-1450 -35 c-18 -29 -92
-65 -120 -58 -38 10 -25 27 47 62 65 33 94 31 73 -4z m2333 -8 c31 -48 -13
-102 -67 -82 -48 18 -48 48 1 48 33 0 36 6 13 31 -9 10 -13 22 -10 27 10 16
46 2 63 -24z m-1877 -53 c0 -18 -42 -61 -61 -61 -27 0 -25 35 3 54 24 17 58
21 58 7z m1356 -89 c8 -19 14 -38 14 -43 0 -16 -28 -10 -64 14 -35 22 -45 37
-26 37 6 0 15 12 20 26 9 22 13 24 26 13 8 -7 22 -28 30 -47z m-625 28 l49 0
0 -60 c0 -47 -4 -64 -20 -80 -29 -29 -75 -26 -97 6 -66 94 -80 109 -106 112
-15 2 -27 7 -27 12 0 14 32 19 94 14 32 -2 81 -4 107 -4z m-1131 -24 c0 -17
-65 -76 -83 -76 -22 0 -51 26 -43 38 4 7 17 12 29 12 12 0 36 9 52 20 36 24
45 25 45 6z m490 -2 c0 -13 -46 -84 -58 -89 -39 -15 -42 28 -5 67 23 24 63 39
63 22z m1744 -44 c6 -6 3 -17 -7 -28 -9 -10 -17 -26 -17 -35 0 -25 -10 -21
-52 18 -40 36 -46 50 -25 59 17 7 90 -3 101 -14z m-1654 1 c0 -19 -38 -97 -53
-109 -13 -11 -17 -10 -26 7 -16 28 -14 32 20 74 28 34 59 49 59 28z m1110 -68
c0 -12 -9 -27 -19 -33 -25 -13 -71 -13 -72 0 -5 29 -2 35 21 40 18 4 26 13 28
35 l4 29 19 -24 c10 -14 19 -35 19 -47z m-1660 22 c0 -20 -44 -65 -63 -65 -8
0 -20 6 -26 14 -13 15 -6 22 54 54 27 15 35 15 35 -3z m2118 -31 c12 -8 22
-22 22 -30 0 -19 -51 -84 -66 -84 -16 0 -67 57 -60 68 3 5 17 7 31 4 22 -4 25
-1 25 27 0 35 14 39 48 15z m-578 -56 c0 -11 -81 -50 -195 -93 -112 -42 -193
-49 -300 -26 -54 12 -57 14 -40 27 13 9 48 14 107 14 104 0 203 29 314 90 l69
38 23 -21 c12 -11 22 -24 22 -29z m-895 -8 c50 -26 113 -47 167 -58 117 -24
130 -37 34 -32 -101 5 -306 82 -306 115 0 23 18 18 105 -25z m-553 3 l26 -28
-37 -37 -37 -36 -33 33 c-33 34 -34 55 -3 55 10 0 23 9 30 20 16 26 23 25 54
-7z m98 -104 c0 -26 22 -24 50 6 24 25 50 33 50 15 0 -21 -61 -107 -84 -119
-32 -18 -74 -7 -87 23 -9 19 -6 31 15 64 27 43 56 48 56 11z m1679 -42 c24 -3
47 -11 51 -17 8 -13 -25 -90 -38 -90 -15 0 -39 25 -70 71 -32 47 -33 65 -3 50
9 -5 36 -11 60 -14z m-1484 -17 c7 -12 -10 -47 -40 -80 -13 -14 -25 -34 -27
-45 -5 -25 -45 -23 -72 4 -18 18 -18 22 -4 58 13 30 24 41 59 54 52 20 76 23
84 9z m728 0 l47 0 0 -54 c0 -63 -16 -86 -61 -86 -32 0 -69 31 -69 58 0 29
-28 60 -60 67 -16 4 -33 11 -36 17 -5 8 13 9 62 5 38 -4 90 -7 117 -7z m591
-55 c3 -8 12 -15 21 -15 8 0 15 7 15 15 0 19 5 19 35 -1 31 -20 37 -39 23 -69
-14 -32 -48 -33 -74 -2 -31 34 -54 74 -47 81 10 10 21 7 27 -9z m-1258 -66
c10 -24 34 -52 54 -65 62 -40 186 -74 310 -85 72 -6 119 -14 128 -23 12 -11 4
-15 -50 -20 -81 -9 -288 23 -381 58 -69 26 -147 73 -147 88 0 20 41 88 54 88
7 0 21 -19 32 -41z m1232 -11 c37 -37 0 -72 -110 -105 -256 -75 -503 -115
-523 -83 -7 11 14 16 125 29 96 11 237 52 290 85 50 30 172 86 191 86 8 0 20
-5 27 -12z m-470 -290 c10 -13 15 -39 13 -69 0 -9 -12 -28 -26 -43 -14 -15
-25 -33 -25 -41 0 -21 -33 -35 -85 -35 -41 0 -46 2 -40 18 4 9 9 22 11 27 6
16 -12 38 -25 31 -6 -4 -11 -20 -11 -35 0 -38 -22 -56 -50 -41 -22 12 -19 30
6 30 18 0 18 11 0 35 -12 16 -16 17 -30 6 -13 -11 -19 -11 -33 0 -9 8 -26 14
-37 14 -14 0 -22 7 -24 21 -3 21 1 22 125 26 l128 3 35 33 c37 35 52 39 68 20z
m-278 -178 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 -4
15 -10z m170 -259 l115 -6 7 -67 c3 -37 9 -72 13 -78 5 -8 -8 -10 -42 -8 -44
3 -48 5 -51 31 -4 33 -22 36 -22 3 0 -28 -22 -49 -46 -44 -22 4 -31 28 -11 28
20 0 28 25 14 39 -6 6 -19 11 -29 11 -14 0 -18 -8 -18 -35 0 -32 -2 -35 -30
-35 -20 0 -30 5 -30 15 0 8 7 15 15 15 19 0 19 34 0 50 -23 19 -45 4 -45 -29
0 -40 -25 -64 -51 -51 -25 14 -24 19 6 30 19 7 25 17 25 39 0 34 -15 48 -34
32 -16 -14 -26 -4 -26 25 0 35 37 57 85 49 22 -4 92 -10 155 -14z m207 -256
c12 -22 36 -80 53 -129 35 -104 33 -108 -50 -104 l-55 3 -27 115 c-24 105 -26
117 -12 138 24 36 63 26 91 -23z m-253 -17 c17 -23 23 -158 8 -158 -4 0 -20
14 -35 31 -21 24 -27 41 -27 78 0 67 26 90 54 49z m105 13 c13 -8 39 -131 40
-188 1 -33 -27 -29 -66 8 -31 28 -33 35 -33 94 0 78 22 109 59 86z m-201 -23
c15 -15 16 -74 1 -83 -5 -4 -21 -4 -35 -1 -20 5 -24 12 -24 45 0 21 3 41 7 44
10 11 38 8 51 -5z m-408 -283 c0 -13 -25 -15 -165 -15 l-165 0 0 -200 c0 -127
-4 -200 -10 -200 -6 0 -10 78 -10 215 l0 215 175 0 c149 0 175 -2 175 -15z
m698 -2 c3 -10 -63 -13 -307 -13 l-311 0 0 -200 c0 -171 -2 -200 -15 -200 -13
0 -15 31 -15 215 l0 215 322 -2 c246 -2 322 -6 326 -15z m612 -213 l0 -210
-282 2 -283 3 -3 208 -2 207 285 0 285 0 0 -210z m-1352 148 c-3 -9 -38 -14
-116 -16 l-112 -3 0 -144 c0 -122 -2 -145 -15 -145 -13 0 -15 24 -15 160 l0
160 131 0 c100 0 130 -3 127 -12z m690 0 c-4 -10 -66 -14 -256 -16 l-252 -2 0
-145 c0 -122 -2 -145 -15 -145 -13 0 -15 24 -15 160 l0 160 271 0 c212 0 270
-3 267 -12z m-251 -114 c61 -30 106 -29 150 5 14 12 39 21 55 21 24 0 32 -6
41 -30 6 -17 22 -34 37 -39 24 -9 24 -9 2 -10 -16 -1 -29 10 -44 35 -18 30
-25 34 -46 29 -14 -3 -38 -15 -53 -26 -38 -26 -96 -24 -153 6 -56 30 -68 31
-90 6 -9 -10 -30 -21 -47 -25 -20 -4 -29 -11 -29 -25 0 -10 -7 -25 -16 -32 -9
-7 -20 -22 -24 -34 -9 -20 -9 -20 -9 1 -1 11 8 29 19 39 11 10 20 27 20 37 0
13 9 20 29 24 17 4 38 15 47 25 23 26 47 24 111 -7z m-415 -13 c15 -8 29 -20
32 -27 3 -9 -6 -5 -24 7 l-29 22 -33 -28 c-18 -15 -38 -42 -45 -60 l-11 -33
46 -6 c26 -3 54 -11 62 -17 11 -7 4 -8 -23 -3 -65 11 -101 10 -127 -3 -14 -7
-34 -13 -45 -12 -12 0 -4 6 20 15 49 18 65 38 65 81 0 34 -26 58 -53 47 -20
-7 -39 -52 -32 -75 4 -11 2 -19 -4 -19 -19 0 -12 56 10 84 23 30 45 33 77 10
27 -18 59 -11 67 17 4 10 9 18 13 16 4 -2 19 -9 34 -16z m401 -45 c44 -33 84
-39 140 -22 34 10 46 11 43 3 -3 -7 -9 -20 -12 -29 -4 -10 -11 -18 -16 -18 -6
0 -8 6 -5 13 3 9 -11 12 -57 12 -53 0 -68 4 -99 28 -20 15 -38 23 -42 17 -6
-10 24 -44 46 -52 8 -3 11 -8 7 -12 -11 -13 -72 49 -65 67 9 23 23 21 60 -7z
m-549 -31 c-4 -8 -8 -15 -10 -15 -2 0 -4 7 -4 15 0 8 4 15 10 15 5 0 7 -7 4
-15z m149 8 c-25 -5 -32 -33 -8 -33 8 0 15 -4 15 -10 0 -15 -16 -12 -34 6 -27
27 -18 45 23 43 24 -2 24 -2 4 -6z m677 -9 l25 -15 -33 7 c-26 4 -37 2 -47
-13 -8 -10 -15 -14 -15 -9 0 11 30 46 39 46 3 -1 17 -7 31 -16z m-349 -4 c10
-6 19 -15 19 -21 0 -5 -11 -3 -24 6 -25 17 -51 12 -60 -11 -3 -8 -11 -14 -17
-14 -7 0 -2 11 11 25 26 27 41 30 71 15z m339 -215 c0 -13 -41 -15 -305 -15
l-305 0 -2 -237 c-2 -178 -6 -237 -15 -241 -10 -3 -13 52 -13 252 l0 256 320
0 c278 0 320 -2 320 -15z m980 -255 l0 -240 -420 0 -420 0 0 240 0 240 420 0
420 0 0 -240z m-1752 203 c3 -10 -53 -13 -257 -13 l-261 0 -2 -217 c-2 -162
-6 -217 -15 -221 -10 -3 -13 48 -13 232 l0 236 272 -2 c206 -2 272 -6 276 -15z
m730 -15 c-4 -10 -67 -14 -261 -16 l-257 -2 0 -186 c0 -144 -3 -185 -12 -182
-10 4 -14 55 -16 201 l-2 197 276 0 c216 0 275 -3 272 -12z m-760 -45 c3 -10
-45 -13 -217 -13 l-221 0 0 -170 c0 -144 -2 -170 -15 -170 -13 0 -15 26 -15
178 0 98 3 182 7 186 4 3 108 5 232 4 169 -2 225 -6 229 -15z m427 -84 c5 -5
23 -9 40 -9 16 0 45 -9 63 -20 39 -24 58 -25 66 -4 4 11 17 14 43 12 32 -2 41
-8 53 -35 17 -37 43 -40 48 -5 2 13 15 28 28 34 34 16 79 -17 79 -58 0 -25 -7
-33 -48 -53 -41 -20 -54 -22 -83 -13 -28 8 -40 7 -71 -9 -20 -10 -51 -19 -68
-18 l-30 1 35 10 c72 21 89 30 100 59 10 24 10 33 -4 55 -22 33 -69 31 -74 -3
-3 -20 -6 -21 -24 -12 -11 6 -35 8 -53 5 -26 -5 -39 -1 -61 17 -40 33 -69 47
-97 47 -38 0 -51 -23 -44 -83 5 -40 4 -48 -5 -33 -6 10 -11 37 -12 58 -1 52
32 82 78 72 17 -3 35 -10 41 -15z m-605 -20 c27 -15 29 -19 10 -14 -58 16 -73
12 -82 -22 -9 -34 -41 -63 -70 -63 -20 0 -52 43 -45 62 3 8 9 2 16 -14 7 -20
18 -28 35 -28 26 0 40 13 51 50 16 54 32 60 85 29z m170 -14 c7 -8 10 -26 8
-40 -4 -19 -1 -25 12 -25 10 0 23 7 30 15 7 8 17 15 23 15 21 0 -26 -39 -55
-45 -37 -8 -41 -4 -29 28 7 18 6 30 -3 42 -11 16 -18 16 -46 6 -38 -13 -55 -6
-19 8 36 14 65 13 79 -4z m440 -40 c22 -14 40 -30 40 -37 0 -7 -6 -6 -17 4
-10 8 -30 22 -44 31 -26 16 -27 15 -22 -6 4 -18 3 -19 -6 -7 -14 19 -14 40 -1
40 6 0 28 -11 50 -25z m-626 -10 c-3 -8 1 -24 10 -37 21 -30 20 -51 -4 -73
-25 -23 -92 -23 -140 -1 -23 11 -27 14 -10 10 62 -14 120 -16 135 -4 17 14 20
56 5 65 -13 8 -13 55 0 55 5 0 7 -7 4 -15z m101 -55 c-6 -43 -4 -50 15 -60 33
-17 108 -3 136 25 13 13 24 20 24 15 0 -28 -61 -60 -116 -60 -63 0 -75 13 -72
80 1 32 6 56 11 53 5 -3 6 -27 2 -53z m531 -25 c22 -17 12 -20 -17 -5 -15 9
-27 5 -56 -14 -20 -14 -39 -23 -42 -19 -3 3 0 8 6 10 7 3 23 13 35 23 28 23
48 25 74 5z"/>
<path d="M4332 2563 l3 -158 218 -3 217 -2 0 160 0 160 -220 0 -221 0 3 -157z
m428 2 l0 -145 -210 0 -210 0 0 145 0 145 210 0 210 0 0 -145z"/>
<path d="M4459 2593 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M4542 2594 c10 -10 20 -16 22 -13 3 3 -5 11 -17 18 -21 13 -21 12 -5
-5z"/>
<path d="M4594 2588 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"/>
<path d="M4480 2556 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z"/>
<path d="M4600 2506 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M4528 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4400 2045 l0 -175 345 0 345 0 0 175 0 175 -345 0 -345 0 0 -175z
m680 0 l0 -165 -335 0 -335 0 0 165 0 165 335 0 335 0 0 -165z"/>
<path d="M4694 2136 c11 -9 24 -16 30 -16 12 0 7 5 -24 19 -24 11 -24 11 -6
-3z"/>
<path d="M4890 2141 c14 -4 27 -17 31 -31 6 -21 7 -22 8 -4 1 26 -17 44 -43
43 -18 -1 -17 -2 4 -8z"/>
<path d="M4979 2083 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M4670 2070 c1 -8 7 -24 15 -34 19 -25 19 -16 0 20 -8 16 -15 22 -15
14z"/>
<path d="M4906 2065 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"/>
<path d="M4580 2060 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M4831 2044 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4528 2043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4984 1988 l-19 -23 23 19 c12 11 22 21 22 23 0 8 -8 2 -26 -19z"/>
<path d="M4837 1969 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M4608 1953 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M3858 2061 c13 -11 30 -17 38 -14 20 8 6 20 -31 28 l-30 6 23 -20z"/>
<path d="M4134 2043 c-10 -33 -22 -48 -35 -45 -14 3 -30 -18 -23 -30 8 -13 73
-9 103 7 36 18 43 37 25 64 -18 26 -62 28 -70 4z"/>
<path d="M6920 5630 c0 -21 -61 -88 -139 -153 l-45 -37 40 -2 c62 -3 145 3
194 13 49 11 160 58 160 68 0 5 -117 80 -187 119 -21 11 -23 11 -23 -8z"/>
<path d="M770 5301 c-17 -27 -38 -55 -46 -61 -7 -7 -14 -16 -14 -20 0 -7 84
-74 117 -94 8 -4 25 12 48 49 33 51 38 54 58 44 50 -26 145 -100 169 -131 33
-44 60 -97 56 -111 -2 -10 -64 -7 -261 12 -141 13 -260 22 -262 19 -5 -4 36
-79 93 -167 l15 -25 9 23 c6 17 13 21 26 16 39 -17 85 -15 237 14 108 21 163
27 170 20 9 -9 11 -148 3 -233 -3 -26 3 -33 55 -64 32 -19 59 -33 61 -31 10
10 36 164 36 213 0 236 -148 418 -440 541 -45 19 -85 35 -90 35 -4 0 -22 -22
-40 -49z"/>
<path d="M6823 5232 c-138 -64 -254 -120 -258 -123 -3 -4 22 -30 55 -59 l61
-52 37 14 c32 12 38 19 42 53 5 39 7 41 100 87 52 27 100 48 107 48 7 0 -14
-75 -56 -197 -65 -187 -117 -370 -109 -379 2 -2 28 4 58 14 82 26 113 61 145
167 15 50 31 94 35 99 11 12 131 -10 148 -27 7 -8 19 -36 26 -63 l12 -49 61
-3 61 -3 4 113 c2 62 3 114 2 116 -1 2 -47 -3 -102 -12 -106 -17 -192 -21
-192 -8 0 4 10 23 22 42 12 19 50 96 84 170 l63 135 -67 17 c-37 10 -71 17
-77 17 -5 0 -123 -53 -262 -117z"/>
<path d="M570 4558 c-53 -152 -89 -234 -129 -292 -17 -24 -31 -48 -31 -53 0
-15 120 -114 130 -108 5 3 26 35 46 70 49 89 53 90 89 30 7 -12 67 -26 230
-55 121 -22 230 -42 243 -45 21 -5 22 -3 22 57 0 89 -49 284 -96 383 -14 30
-25 37 -83 54 -72 21 -341 81 -364 81 -9 0 -29 -43 -57 -122z m250 -43 c145
-34 141 -31 170 -160 13 -61 15 -85 6 -85 -21 0 -316 67 -323 73 -8 9 25 136
43 165 17 26 20 26 104 7z"/>
<path d="M7310 4396 l0 -144 -110 -27 c-60 -15 -117 -28 -125 -29 -13 -1 -30
38 -74 164 l-57 165 -69 3 c-52 2 -66 0 -63 -10 3 -7 38 -118 79 -246 43 -136
80 -237 89 -242 8 -4 36 -11 63 -14 42 -6 47 -5 47 11 0 41 25 54 151 84 68
16 142 34 163 40 l39 11 -6 96 c-7 107 3 164 36 200 l20 22 -24 0 c-13 0 -53
14 -87 30 -35 17 -66 30 -68 30 -2 0 -4 -65 -4 -144z"/>
<path d="M723 3900 c-120 -72 -55 -261 85 -247 46 5 84 32 108 79 59 113 -83
236 -193 168z"/>
<path d="M7193 3900 c-40 -24 -63 -67 -63 -117 0 -101 112 -165 197 -113 66
40 88 111 55 177 -35 68 -123 93 -189 53z"/>
<path d="M6791 3483 c34 -40 82 -136 94 -190 9 -42 18 -41 45 2 14 23 29 35
43 35 12 0 132 -33 267 -74 135 -41 247 -72 249 -71 9 9 -59 80 -122 129 -94
71 -162 107 -272 146 -83 29 -242 60 -309 60 l-28 0 33 -37z"/>
<path d="M980 3501 c0 -20 -52 -70 -92 -88 -58 -27 -108 -38 -277 -63 -80 -11
-147 -22 -149 -24 -8 -8 134 -47 210 -58 l78 -11 31 -48 c70 -110 184 -180
326 -200 105 -15 113 -12 113 48 1 26 7 64 14 84 l13 37 -76 6 c-42 4 -88 9
-102 12 -24 5 -27 2 -33 -36 -8 -49 -28 -52 -103 -15 -39 20 -56 36 -72 67
-11 23 -18 45 -16 49 3 3 25 10 49 13 93 14 214 97 255 175 14 24 17 22 -75
46 -71 17 -94 19 -94 6z"/>
<path d="M6736 2957 c-69 -146 -124 -236 -203 -335 l-51 -62 35 -92 c19 -51
37 -96 40 -101 2 -4 23 13 45 38 22 25 44 45 49 45 5 0 14 -12 20 -27 16 -44
47 -71 132 -116 139 -74 156 -112 111 -248 -3 -9 13 -37 41 -70 25 -29 48 -64
51 -76 4 -13 12 -23 20 -23 20 0 19 235 -1 314 -34 132 -101 225 -226 316 -42
31 -69 57 -69 69 0 24 117 261 129 261 35 0 184 -36 271 -65 57 -19 106 -33
109 -30 2 3 -22 45 -55 92 -71 103 -138 155 -265 201 -46 16 -92 33 -101 37
-15 6 -29 -15 -82 -128z"/>
<path d="M1136 2845 c5 -20 2 -25 -12 -25 -34 -1 -60 -23 -174 -150 -62 -69
-117 -126 -122 -128 -15 -6 -104 95 -134 152 -19 37 -34 54 -44 52 -8 -3 -41
-7 -72 -11 -32 -3 -58 -9 -58 -12 0 -3 19 -41 42 -85 27 -52 63 -102 104 -143
102 -102 212 -145 370 -145 106 0 165 10 287 47 89 27 89 27 83 56 -3 16 -6
54 -6 83 l0 54 -85 0 -86 0 6 -37 c18 -112 21 -101 -32 -110 -97 -16 -195 -8
-256 20 -31 14 -57 30 -57 34 1 4 103 73 228 153 l228 145 -100 37 c-56 21
-104 38 -109 38 -4 0 -5 -11 -1 -25z"/>
<path d="M6351 2264 c-36 -24 -71 -44 -78 -44 -7 0 -13 -2 -13 -4 0 -11 82
-156 88 -156 4 0 22 9 40 20 41 25 74 25 96 1 29 -32 34 -259 8 -381 -24 -114
-56 -202 -86 -237 l-22 -26 -57 28 c-32 16 -62 34 -67 40 -7 8 0 32 23 76 30
59 32 71 31 159 0 106 -16 158 -74 247 l-33 51 -43 -33 c-23 -18 -53 -35 -67
-38 l-24 -7 20 -90 20 -90 32 20 c18 11 46 20 63 20 25 0 35 -6 48 -32 31 -59
3 -248 -37 -248 -21 0 -155 100 -212 158 l-59 59 -66 -28 c-37 -16 -75 -29
-86 -29 -10 0 -16 -5 -14 -12 3 -7 18 -49 33 -93 16 -44 30 -82 31 -84 2 -2
23 13 48 33 24 20 47 36 50 36 4 0 34 -22 69 -48 157 -123 323 -216 438 -246
l54 -14 22 49 c34 73 71 213 84 314 22 170 -7 373 -75 519 -30 65 -98 157
-115 155 -3 0 -35 -20 -70 -45z"/>
<path d="M1350 2273 c0 -21 -35 -82 -59 -101 -37 -30 -146 -74 -301 -121 -157
-47 -163 -50 -135 -61 17 -6 71 -16 120 -22 108 -12 252 5 380 46 88 28 259
115 258 131 0 6 -59 41 -131 78 -109 56 -132 65 -132 50z"/>
<path d="M1545 1939 c-8 -23 -92 -88 -189 -145 -54 -31 -63 -40 -50 -47 25
-14 231 -1 294 18 66 20 170 65 170 74 0 6 -203 121 -214 121 -2 0 -8 -9 -11
-21z"/>
<path d="M2235 1570 c-22 -16 -64 -39 -93 -51 l-52 -21 125 -99 124 -99 -35
-78 c-19 -42 -45 -98 -56 -124 -11 -27 -21 -48 -22 -48 -1 0 -82 29 -181 65
l-180 66 -47 -53 c-26 -29 -44 -56 -40 -59 10 -9 504 -199 517 -199 6 0 30 18
55 39 43 37 44 39 28 58 -10 11 -18 30 -18 44 0 13 34 94 75 179 l74 155 -27
22 c-15 12 -56 44 -91 70 -73 54 -100 87 -110 131 l-6 30 -40 -28z"/>
<path d="M5586 1430 c-21 -68 -40 -129 -43 -137 -4 -9 4 -13 22 -13 80 0 133
-60 246 -277 63 -122 75 -139 82 -120 12 31 -1 165 -24 249 -37 134 -113 273
-206 377 l-39 44 -38 -123z"/>
<path d="M5250 1271 l0 -83 69 7 69 7 7 -67 c4 -37 5 -92 1 -122 -7 -58 -39
-145 -61 -163 -9 -7 -46 48 -151 226 -76 130 -140 231 -142 223 -3 -8 -22 -55
-43 -106 -22 -51 -39 -95 -39 -98 0 -3 9 -1 20 5 15 8 21 6 30 -9 5 -11 10
-26 10 -33 0 -7 60 -73 133 -146 l132 -133 -54 -49 c-29 -27 -77 -59 -107 -72
-52 -22 -54 -24 -53 -63 0 -22 3 -57 7 -77 l7 -38 93 46 c159 77 258 198 292
355 18 83 8 273 -21 384 l-24 90 -87 0 -88 0 0 -84z"/>
<path d="M2735 1268 c-66 -22 -121 -42 -123 -43 -2 -2 4 -17 12 -34 37 -71 18
-147 -95 -366 -39 -75 -69 -139 -66 -141 8 -8 98 59 153 114 94 94 171 222
218 360 27 80 41 152 29 151 -4 0 -62 -19 -128 -41z"/>
<path d="M2986 1164 c-35 -79 -35 -79 87 -124 52 -20 92 -41 98 -52 8 -15 -8
-59 -85 -226 -52 -113 -93 -208 -91 -210 6 -7 91 41 133 75 108 88 269 362
242 412 -5 10 -42 30 -82 46 -128 50 -222 95 -248 120 l-26 25 -28 -66z"/>
<path d="M4840 1090 c-77 -41 -141 -54 -272 -55 l-126 0 -41 -83 c-23 -45 -41
-84 -41 -87 0 -3 74 -5 165 -5 149 0 167 -2 184 -19 18 -18 37 -72 92 -266
l23 -79 24 74 c34 107 40 238 15 312 -19 55 -19 57 -1 93 13 24 18 52 16 85
l-3 48 -35 -18z"/>
<path d="M3546 1078 c-3 -13 -26 -50 -51 -82 -24 -33 -43 -61 -41 -63 1 -2 68
-15 147 -29 79 -15 147 -29 151 -33 4 -3 10 -65 14 -137 l7 -131 -23 -6 c-13
-3 -99 -16 -190 -29 l-167 -23 -17 -69 c-9 -38 -15 -70 -14 -71 2 -2 127 12
278 31 151 18 278 34 281 34 12 0 50 115 40 118 -6 2 -21 12 -33 22 -26 20
-36 99 -37 283 -1 59 -4 107 -9 107 -4 0 -46 5 -92 10 -108 13 -171 34 -200
65 -29 31 -36 31 -44 3z"/>
<path d="M4467 707 l-57 -53 0 -132 c0 -73 4 -132 9 -132 16 0 73 73 94 119
23 51 36 207 20 235 -8 14 -18 8 -66 -37z"/>
</g>
</svg>
    </>
  )
}
